module.exports = __webpack_public_path__ + "static/media/iconEmail.530e5a9a.svg";